export enum MailTemplateKind {
    SingleFile = 'SingleFile',
    MultipleFiles = 'MultipleFiles',
    UnsettledDocumentReminder = 'UnsettledDocumentReminder',
    MultipleUnsettledDocumentReminder = 'MultipleUnsettledDocumentReminder',
    AccountingDataExchangeEmail = 'AccountingDataExchangeEmail'
}
